export default {
  form: {
    amount: {
      label: 'Hinta',
    },
    has_sales_based_discount: {
      label: 'Alennukset kuukausimyynnin perusteella',
    },
  },
  labels: {
    month: 'kuukausi',
    varies_by_tier: 'vaihtelee tason mukaan',
    max_price: '* Enimmäishinta on {{amount}}',
    sales_based_discount:
      'jopa +{{threshold}} vähimmäismyynti yhdessä kuukaudessa. Sen jälkeen normaalihinta {{amount}} netto/kuukausi',
  },
  tax: {
    inclusive: '{{taxName}}: {{tax}} (sisältyy)',
    exclusive: 'kuukaudessa plus {{taxName}}: {{tax}}',
  },
  buttons: {
    select: 'Valitse',
    save: 'Tallenna',
    use_default_price: 'Käytä oletushintaa',
  },
};
